import React from 'react';
import { Card, Row, Col, Button, Table } from 'react-bootstrap';
import { FaBolt, FaEdit, FaMapMarkerAlt, FaCity, FaMap, FaIndustry } from 'react-icons/fa';

// Targeta de resum del CUPS (codi, adreça, potències); usada a OfertaDetail i ContratoDetail.
const CupsCard = ({ cupsData, onEdit }) => {
    return (
        <Card className="h-100 border-0 shadow-sm rounded-4 overflow-hidden">
            <Card.Header className="bg-white border-bottom-0 pt-4 px-4 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <FaBolt className="me-2" />
                    Información del CUPS
                </div>
                {onEdit && (
                    <Button
                        variant="link"
                        className="p-0"
                        onClick={onEdit}
                        title="Editar CUPS"
                        aria-label="Editar información del CUPS"
                    >
                        <FaEdit size={18} />
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                <Row className="g-4">
                    <Col md={12}>
                        <div className="d-flex align-items-center">
                            <FaBolt className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">CUPS</label>
                                <p className="detail-card-value text-truncate" style={{ color: 'var(--ab-primary)' }}>{cupsData.code || "No especificado"}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={12}>
                        <div className="d-flex align-items-center">
                            <FaMapMarkerAlt className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Dirección de Suministro</label>
                                <p className="detail-card-value">{cupsData.address || <span className="text-muted fst-italic">No especificada</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaMap className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Código Postal</label>
                                <p className="detail-card-value">{cupsData.zip || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <FaCity className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">Municipio / Provincia</label>
                                <p className="detail-card-value">
                                    {cupsData.city}{cupsData.city && cupsData.province ? ', ' : ''}{cupsData.province}
                                    {(!cupsData.city && !cupsData.province) && <span className="text-muted fst-italic">No especificado</span>}
                                </p>
                            </div>
                        </div>
                    </Col>

                    <Col md={12}>
                        <div className="d-flex align-items-center">
                            <FaIndustry className="detail-card-icon" />
                            <div>
                                <label className="detail-card-label">CNAE</label>
                                <p className="detail-card-value">{cupsData.cnae || <span className="text-muted fst-italic">No especificado</span>}</p>
                            </div>
                        </div>
                    </Col>

                    {cupsData.potencias && Object.keys(cupsData.potencias).length > 0 && (
                        <Col md={12}>
                            <div className="mt-2">
                                <label className="detail-card-label">Potencias Contratadas</label>
                                <div className="table-responsive">
                                    <Table size="sm" bordered hover className="mb-0 text-center">
                                        <thead className="bg-light">
                                            <tr>
                                                {Object.keys(cupsData.potencias).map(periodo => (
                                                    <th key={periodo} className="fw-normal small text-muted">{periodo}</th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {Object.values(cupsData.potencias).map((potencia, idx) => (
                                                    <td key={idx} className="fw-bold text-dark">{potencia} kW</td>
                                                ))}
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default CupsCard;
